<section id="nr_topStrip" class="row">
    <div class="container">
        <div class="row">
            <ul class="list-inline c-info fleft">
                <li><a href="tel:966599454045"><i class="fa fa-phone"></i> +966 59 945 4045</a></li>
                <li><a href="mailto:info@misk-co.com"><i class="fa fa-envelope-o"></i> info@misk-co.com</a></li>
            </ul>
            <ul class="list-inline c-info lang fright">
                <li *ngIf="!dir"><a (click)="changeLangAR()" style="cursor: pointer;"> عربي</a></li>
                <li *ngIf="dir"><a  (click)="changeLangEN()" style="cursor: pointer;"> English</a></li>
            </ul>
        </div>
    </div>
</section>
<!--Top Strip-->

<header class="row">
    <div class="container">
        <div class="row">
            <div class="logo col-sm-6 fleft">
                <div class="row">
                    <a routerLink="/home"><img src="../../../assets/images/logo.png"
                            alt="MISK - Engineering Consultants  "></a>
                </div>
            </div>
            <div class="social_nav col-sm-6">
                <div class="row">
                    <ul class="list-inline fright">
                        <li><a href="https://www.facebook.com/MISK-Consulting-Engineers-114435089963498"><i
                                    class="fa fa-facebook"></i></a></li>
                        <li><a href="https://twitter.com/MiskConsulting"><i class="fa fa-twitter"></i></a></li>
                        <li><a href="https://www.linkedin.com/in/MiskConsulting"><i class="fa fa-linkedin"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>
<!--Header-->


<nav class="navbar navbar-default navbar-static-top">
    <div class="container-fluid container">
        <div class="row m04m">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#main_nav">
                    <span class="bars">
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </span>
                    <span class="btn-text">{{'SelectPage' | translate}}</span>
                </button>
            </div>
            <div class="collapse navbar-collapse" id="main_nav">
                <ul class="nav navbar-nav">
                    <li routerLinkActive="active"><a routerLink="/home">{{'Home' | translate}}</a></li>
                    <li class="dropdown" routerLinkActive="active">
                        <a routerLink="/about" class="dropdown-toggle" data-toggle="dropdown" role="button"
                            aria-expanded="false">{{'Office' | translate}}</a>
                        <ul class="dropdown-menu" role="menu">
                            <li><a routerLink="/about">{{'Aboutus' | translate}}</a></li>
                            <li><a routerLink="/team">{{'Staff' | translate}}</a></li>
                            <li><a routerLink="/vision">{{'OurVision' | translate}}</a></li>
                        </ul>

                    </li>
                    <li class=" dropdown" routerLinkActive="active">
                        <a routerLink="/projects">{{'projects' | translate}}</a>
                        <!--<ul class="dropdown-menu" role="menu">
                            <li><a href="projects_full.html">Full Width Projects</a></li>
                            <li><a href="projects2.html">2 Collumn Projects</a></li>
                            <li><a href="projects3.html">3 Collumn Projects</a></li>
                        </ul>-->
                    </li>
                    <li class=" dropdown " routerLinkActive="active">
                        <a routerLink="/project-management" class="dropdown-toggle" data-toggle="dropdown" role="button"
                            aria-expanded="false">{{'services' | translate}}</a>
                        <ul class="dropdown-menu" role="menu">
                            <li class=" dropdown ">
                                <a routerLink="/project-management">
                                    {{'PMO' | translate}}
                                </a>
                            <li>
                                <a routerLink="/facility-management">
                                    {{'FacilityManagement' | translate}}
                                </a>
                            </li>
                            <li><a routerLink="/arbitration">{{'Arbitration' | translate}}</a></li>
                            <li class="dropdown submenu">
                                <a href="#" data-toggle="dropdown" role="button" aria-expanded="false">{{'OtherServices' | translate}} <i
                                        class="fa fa-arrow-right"></i></a>
                                <ul class="dropdown-menu dropdown-content" role="menu">
                                    <li>
                                        <a routerLink="/planning">
                                            {{'Planning' | translate}}
                                        </a>
                                    </li>
                                    <li>
                                        <a routerLink="/designing">
                                            {{'Designing' | translate}}
                                        </a>
                                    </li>
                                    <li>
                                        <a routerLink="/supervision">
                                            {{'SUPERVISION' | translate}}
                                        </a>
                                    </li>
                                    <li>
                                        <a routerLink="/construction-management">
                                            {{'ConstructionManagement' | translate}}
                                        </a>
                                    </li>
                                    <li><a routerLink="/roads">{{'Roads' | translate}}</a></li>
                                    <li><a routerLink="/environmental-sustainability">{{'EnvironmentalSustainability' | translate}}</a></li>
                                    <li><a routerLink="/vision-realization">{{'VRO' | translate}}</a></li>
                                    <li><a routerLink="/green-buildings">{{'GreenBuildings' | translate}}</a></li>
                                    <li><a routerLink="/infrastructure">{{'Infrastructure' | translate}}</a></li>
                                </ul>
                            </li>



                        </ul>


                    </li>
                    <li class=" dropdown" routerLinkActive="active">
                        <a routerLink="/consultation">{{'Consultation' | translate}}</a>
                        <!--<ul class="dropdown-menu" role="menu">
                            <li><a href="blog.html">Blog</a></li>
                            <li><a href="blog2.html">Blog 2 Col</a></li>
                            <li><a href="blog3.html">Blog 3 Col</a></li>
                            <li><a href="single-post.html">Sinlge Post</a></li>
                        </ul>-->
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/contact">{{'contact' | translate}}</a>
                        <!--<ul class="dropdown-menu" role="menu">
                            <li><a href="contact.html">Conact us</a></li>
                            <li><a href="contact2.html">Conact us 2</a></li>
                        </ul>-->
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/career">{{'Career' | translate}}</a>
                        <!--<ul class="dropdown-menu" role="menu">
                            <li><a href="contact.html">Conact us</a></li>
                            <li><a href="contact2.html">Conact us 2</a></li>
                        </ul>-->
                    </li>
                </ul>
            </div>
        </div>
    </div>
</nav>
<!--Main Nav-->